"use client";

import { useUser } from "@/context/user-context";
import { slugify } from "@/utils/slugify";
import classNames from "classnames";
import Link from "next/link";
import { useId } from "react";
import Icon from "./icon";

type ArticleTagProps = {
  tag: string;
  className?: string;
};

const ArticleTag = (props: ArticleTagProps) => {
  const ariaId = useId();

  const { user, toggleTopic, isAuthenticated } = useUser();

  const isSubscribed = user
    ? user?.topics?.find((item) => item.id === props.tag && item.type === "tag")
    : false;

  if (isAuthenticated) {
    return (
      <span
        role="group"
        aria-labelledby={ariaId}
        className={classNames(
          `btn p-0 rounded-sm hover:bg-sand-800`,
          isSubscribed ? "bg-sand-700" : "bg-sand-700",
          props.className,
        )}
      >
        <button
          aria-label={`Följ ${props.tag}`}
          aria-pressed={Boolean(isSubscribed)}
          onClick={() =>
            user ? toggleTopic({ type: "tag", id: props.tag }) : null
          }
          className="w-full h-full bg-sand-800 p-3 rounded-l-sm"
        >
          {user && isSubscribed ? (
            <Icon.CheckCircle
              className="size-[18px] fill-green-500 text-green-500"
              aria-label="följer"
            />
          ) : (
            <Icon.PlusCircle className="size-[18px] fill-black-500 text-black-500" />
          )}
        </button>
        <Link
          id={ariaId}
          href={`/tagg/${slugify(props.tag)}`}
          className="font-bold px-2 text-base text-nowrap"
        >
          {props.tag}
        </Link>
      </span>
    );
  }

  return (
    <Link
      className={classNames(
        "bg-sand-700 px-3 py-2 rounded-sm font-bold",
        props.className,
      )}
      href={`/tagg/${slugify(props.tag)}`}
    >
      {props.tag}
    </Link>
  );
};

export default ArticleTag;
